export const productTabNames = {
  'products info': true,
  出展製品: true,
  出展制品: true,
  'special offer': true,
  product: true,
  products: true,
  商品: true,
  产品: true,
  產品: true,
  'sản phẩm': true,
};

const isProductsTab = (tabName: string): boolean => tabName?.toLowerCase() in productTabNames;

export default isProductsTab;
